import { default as MnemonicModal } from './PrivateKeyModal'
export default MnemonicModal
